import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import TransshipmentForm from "./TranshipmentController/TransshipmentForm";

import {
  useGetTransshipmentDetailQuery,
  useUpdateTransshipmentMutation
} from "store/services/transhipmentApi";

import { useAppMeta } from "hooks";

const TransshipmentEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Transshipment", path: "/app/crm/transshipment/list" },
    { title: "Edit Transshipment" },
  ];

  // RTK Query
  const {
    data: transshipmentDetail,
    isLoading: loadingTransshipment,
    error,
  } = useGetTransshipmentDetailQuery(id)

  const [updateTransshipment, { isLoading: updatingTransshipment }
  ] = useUpdateTransshipmentMutation();

  // methods
  const handleUpdateTransshipment = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateTransshipment({ ..._payload },).unwrap();
      toast.success("Transshipment successfully updated!");
      navigate(`/app/crm/transshipment/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Transshipment!"
      );
    }
  };

  useAppMeta("Edit Transshipment");
  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingTransshipment || updatingTransshipment}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <TransshipmentForm
          isBusy={loadingTransshipment || updatingTransshipment}
          transshipmentDetail={transshipmentDetail}
          onSubmit={handleUpdateTransshipment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default TransshipmentEditScreen